import React, {useState} from 'react'
import {Box, Paper, TextField, Typography, Button} from '@mui/material'
import { useNavigate, Link } from 'react-router-dom'
import {useDispatch} from 'react-redux'
import { validateUser} from '../../features/userAuth/userThunk'
import {logIn} from '../../features/userAuth/userAuth'


const Login = () => {
const dispatch = useDispatch()
const navigate= useNavigate()
const [details, setDetails] = useState({ Email:'', Password:""})
  
const handleSubmit = (e) => {
e.preventDefault()
dispatch(validateUser(details))
dispatch(logIn())
navigate('/')
  }
  return (
    <Paper elevation={2} sx={{margin:'0 auto',marginTop:'2rem', width: '300px', padding:'1rem', paddingTop: '1.3rem'}}>
      
      <Box 
      component='form'
     noValidate
      autoComplete='off'
      onSubmit={handleSubmit}
        sx={{display:'flex', flexDirection:'column', gap:'0.8rem', justifyContent: 'center'}}
      >
        <Typography variant="h6" component='h1' sx={{margin:"0.2rem auto"}}>Sign In</Typography>
         <TextField 
       type='email'
       name='Email'
         value={details.Email}
         onChange={(e) => setDetails({...details, Email: e.target.value})}
       label= 'Email' 
       placeholder='Enter email...'
       sx={{width:'100%'}}
       />
         <TextField 
       type='password'
       name='Password'
      value={details.Password}
      onChange={(e) => setDetails({...details, Password: e.target.value})}
       label= 'Password' 
       placeholder='Enter password...'
       sx={{width:'100%'}}
       />
      
     
       <Button type='submit' variant='contained' color='primary'>Sign in</Button>
      
      </Box>
      <div>
        <p>Do not have an account? <Link to='/register'>Create an account</Link></p>
      </div>
    </Paper>
  )
}

export default Login